import { useEffect, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { motion, AnimatePresence, useDragControls } from 'framer-motion';
import { drawerVariant, overlayVariant } from './const';

import styles from './styles.module.css';

const MotionBox = motion(Box);

const Drawer = ({ children, className, height, isOpen = true, onClose, draggable = false }) => {
  const dragControls = useDragControls();
  const [isAnimating, setIsAnimating] = useState(false);

  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = 'hidden';
      setIsAnimating(false);
    } else {
      document.body.style.overflow = '';
    }

    return () => {
      document.body.style.overflow = '';
    };
  }, [isOpen]);

  const handleClose = () => {
    setIsAnimating(true);
    setTimeout(() => {
      if (onClose) {
        onClose();
      }
    }, 250);
  };

  const handleDragEnd = (_event, info) => {
    if (!draggable) return;

    const dragDistance = info.offset.y;
    const dragVelocity = info.velocity.y;

    const hasHighVelocity = dragVelocity > 800;
    const movedDownEnough = dragDistance > 100;

    const shouldClose = hasHighVelocity && movedDownEnough;

    if (shouldClose) {
      handleClose();
    }
  };

  const dragProps = draggable
    ? {
        drag: 'y',
        dragControls: dragControls,
        dragConstraints: { top: 0, bottom: 0 },
        dragElastic: { top: 0, bottom: 0.3 },
        onDragEnd: handleDragEnd,
        dragMomentum: false,
        dragListener: false,
      }
    : {};

  const shouldShow = isOpen && !isAnimating;

  return (
    <AnimatePresence>
      {shouldShow && (
        <MotionBox className={styles['drawer__container']} initial="hidden" animate="visible" exit="exit">
          <MotionBox className={styles['drawer__overlay']} variants={overlayVariant} onClick={handleClose} transition={{ duration: 0.2 }} />
          <MotionBox className={`${styles['drawer__content']} ${className}`} height={height} variants={drawerVariant} {...dragProps}>
            {draggable && (
              <Box className={styles['drag-handle__container']} onPointerDown={(e) => dragControls.start(e)} style={{ touchAction: 'none' }}>
                <Box className={styles['drag-handle']} />
              </Box>
            )}
            {children}
          </MotionBox>
        </MotionBox>
      )}
    </AnimatePresence>
  );
};

export default Drawer;
